import { render, staticRenderFns } from "./PopUpCompany.vue?vue&type=template&id=2d64b997"
import script from "./PopUpCompany.vue?vue&type=script&lang=js"
export * from "./PopUpCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d64b997')) {
      api.createRecord('2d64b997', component.options)
    } else {
      api.reload('2d64b997', component.options)
    }
    module.hot.accept("./PopUpCompany.vue?vue&type=template&id=2d64b997", function () {
      api.rerender('2d64b997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/PopUps/PopUpCompany.vue"
export default component.exports